<template>
  <div>
    <footer class="page-footer font-small orange darken-1" expand="large" ref="footer">
      <div class="container text-center text-md-left" v-if="!madeChoice">
        {{$t("main.googleAnalytics.cookiesPurpose")}}
        <br />
        <router-link :to="{name:'termsofuse'}">({{$t("main.googleAnalytics.privacyPolicy")}})</router-link>
        <br />
        <mdb-btn
          color="brown lighten-1"
          rounded
          size="sm"
          @click="disableTracking"
        >{{$t("main.googleAnalytics.disableCookies")}}</mdb-btn>
        <mdb-btn
          color="brown lighten-1"
          rounded
          size="sm"
          @click="enableTracking"
        >{{$t("main.googleAnalytics.enableCookies")}}</mdb-btn>
      </div>
      <!-- Copyright -->
      <div class="footer-copyright text-center py-3">
        Made with
        <mdb-icon icon="heart" /> by
        <a href="mailto:info@dbloke.be">DBloke</a>
      </div>
      <!-- Copyright -->
    </footer>
  </div>
</template>

<script>
import { mdbIcon } from "mdbvue";
export default {
  name: "GoogleAnalytics",
  components: { mdbIcon },
  data() {
    return {
      enabled: true,
      madeChoice: false
    };
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    disableTracking: function() {
      try {
        this.$ga.disable();
        this.enabled = false;
        let thiss = this;
        setTimeout(() => thiss.onResize(), 10);
      } catch (e) {
        console.log(e);
      }
      this.madeChoice = true;
    },
    enableTracking: function() {
      try {
        this.$ga.enable();
        this.enabled = true;
        let thiss = this;
        setTimeout(() => thiss.onResize(), 10);
      } catch (e) {
        console.log(e);
      }
      this.madeChoice = true;
    },
    onResize: function() {
      let h = this.$refs.footer.clientHeight;
      this.$refs.footer.parentNode.parentNode.style.paddingBottom =
        h + 50 + "px";
    }
  },
  mounted: function() {
    this.onResize();
  }
};
</script>

<style>
html {
  height: 100%;
}
body {
  min-height: 120%;
  position: relative;
}
.page-footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding-top: 10px;
}
</style>